<script>
	// svelte/d3 libs
	// import * as d3 from 'd3';
	import { line as d3line} from 'd3';
	import { scaleLinear } from 'd3-scale';
	import { draw, fade } from 'svelte/transition';
	import { tweened } from 'svelte/motion';
	import { linear } from 'svelte/easing';

	import { Delaunay } from 'd3-delaunay';
	import {throttle} from '../actions/throttle.js';
	import inView from '../actions/inView.js';
    import State from '../stores/State.js'; 

	

	// data
	export let driverLaps;// = driversDefault;
	export let replaying;
	export let scaleFactor;

	let playing = false;
	let winW;
	let winH;

	let mPos = { x: 0, y: 0 }; 
	// voronoi mouse catching radius
	let radius = 25;
	let pickedDot = {"driver":""};

	let width = 700;
	$: height = winH < 770 ? 400 : 450;

	$: driverLaps.push(driverLaps.splice(driverLaps.findIndex(o => o.driver === $State.selDriver), 1)[0]);

	const padding = { top: 4, right: 45, bottom: 25, left: 25 };

	$: allPoints = flattenDL(driverLaps);
	$: delaunay = Delaunay.from(allPoints, d => $State.l_x(d.vsP105), d => $State.l_y(d.lap))

	$: xExtent = [$State.selRace.minP105, $State.selRace.maxP105];
		
	$: yTicks = getYticks ($State.selRace.lapCount);

	$: $State.l_x = scaleLinear()
		.domain([$State.selRace.minP105, $State.selRace.maxP105])
		.range([padding.left, width - padding.right]);

	$: $State.l_y = scaleLinear()
		.domain([$State.selRace.race === 'Belgium' ? 0 : 1, $State.selRace.lapCount])
		.range([padding.top, height - padding.bottom]);

	$: pickedDot = getNewPickedDot($State.selRace); 

	$: scaled = scaleFactor < 0.97;



	function getNewPickedDot (selectedRace) {
		const pickedPath = allPoints.filter((d) => d.driver===$State.selDriver)
		if (pickedPath.length > 0){
			return pickedPath[pickedPath.length-1];
		}
		else {
			return {"driver":""};
		}
	}

	let chartLine = d3line()
		.x(function(d) { return $State.l_x(d.vsP105); }) 
		.y(function(d) { return $State.l_y(d.lap); });
//		.curve(curveMonotoneY);


	function getYticks (lapCount) {
		let x = [];
		let i = 10;
		while (i < lapCount) {
			x.push(i);
			i = i + 10;
		}
		if (x[x.length-1]+3 <= lapCount) x.push(lapCount);
		return x;
	}




	const distance = (px, py, mx, my) => {
		const a = px - mx;
		const b = py - my;

		return Math.sqrt(a * a + b * b);
	}

	const mouseMove = (e) => {
		let cRect = e.target.getBoundingClientRect();
		mPos.x = (e.clientX - cRect.left) / scaleFactor;
		mPos.y = (e.clientY - cRect.top) / scaleFactor;
		// pickedDot = {"driver":""};
		
		// if mouse is directly over a path, return a point on that path
		if (e.target.nodeName === "path") {
			const dr = e.target.dataset.value;
			const lp = Math.round($State.l_y.invert((mPos.y+padding.top)));
			pickedDot = allPoints.filter((d) => d.driver===dr && d.lap === lp)[0];
		}
		// if mouse is not on the path pick the closest dot as long as it is within the radius
		else {
			const idx = delaunay.find(mPos.x, mPos.y);
			if (idx !== null) {
				const datum = allPoints[idx];
				if (distance($State.l_x(datum.vsP105), $State.l_y(datum.lap), mPos.x, mPos.y) < radius){
					pickedDot = datum;
				}
				else {
					// *****
					// commented code will go back to the selected line's last point if you are outside a dot radius, but this felt like an annoying 
					// *****
					// const pickedPath = allPoints.filter((d) => d.driver===$State.selDriver);
					// if (pickedPath.length > 0){
					// 	pickedDot = pickedPath[pickedPath.length-1];
					// }
					// else {
						pickedDot = {"driver":""};
					// }
				}	
			}
		}
		// if(typeof pickedDot === 'undefined') {
		// 	pickedDot = {"driver":""};
		// }
	}
	
	const mouseLeave = () => {
		const pickedPath = allPoints.filter((d) => d.driver===$State.selDriver);
		if (pickedPath.length > 0){
			pickedDot = pickedPath[pickedPath.length-1];
		}
		else {
			pickedDot = {"driver":""};
		}
	}

	const selectLine = (e) => {
		if (pickedDot.driver) {
			$State.selDriver = pickedDot.driver;
		}
	}




	const flattenDL = (data) => {
		let x = [];
		for (const d of data) {
			for (const l of d.laps) {
				x.push(l);
			}
		}
		return x
	}


	let sound = new Audio('/audio/thunder-start.mp3');

	function playSound() {
		sound.currentTime = 0
		sound.play();
	}

</script>

	
<svelte:window bind:innerWidth={winW} bind:innerHeight={winH}/>

<container>

	<!-- For some reason binding breaks safari in this chart - width gets set to zero -->
	<!-- bind:clientWidth={width} bind:clientHeight={height}  -->
<div class="chart" bind:clientWidth={width} id="lightningChart" out:fade="{{delay: $State.noFade ? 0 : 500, duration: $State.noFade ? 0 : 800}}" use:inView on:enter={() => $State.chartFirstVisible = true}>
	
	{#if $State.chartFirstVisible}
	<svg id="LRPlot" on:mousemove={throttle(mouseMove, 200)} on:mouseleave="{mouseLeave}" on:click="{selectLine}">
		<defs>
			<linearGradient id="grad-blue2whiteTween" x1="0%" y1="0%" x2="0%" y2="100%">
				<stop stop-color="#5C86B5" stop-opacity="{0.2}"/>
				<stop offset="0.7" stop-color="#5C86B5" stop-opacity="0.5"/>
				<stop offset="0.95" stop-color="#5C86B5"/>
				<stop offset="0.98" stop-color="#B2CAE6"/>
				<stop offset="1" stop-color="#B2CAE6"/>
			</linearGradient>
			<linearGradient id="grad-red2whiteTween" x1="0%" y1="0%" x2="0%" y2="100%">
				<stop stop-color="#FF3263" stop-opacity="0.7"/>
				<stop offset="0.7" stop-color="#FF3263" stop-opacity="0.8"/>
				<stop offset="1" stop-color="#FF3263"/>
			</linearGradient>
			<!-- <filter id="blur1"x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="1" /></filter>
			<filter id="blur0-3"x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="0.3" /></filter>
			<filter id="blur0-6"x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="0.6" /></filter> -->
		</defs>
		

		<!-- y axis -->
		<g class="axis y-axis">
			{#each yTicks as tick}
				<g class="tick tick-{tick}" transform="translate(0, {$State.l_y(tick)})">
					<line x2="{width - padding.right}px"></line>
					<text y="-4">{tick === 10 ? 'Lap ' : ''} {tick}</text>
				</g>
			{/each}
		</g>

		
		<!-- chart elements -->		
		<g class="bolts">
			{#key replaying}
			{#each driverLaps as driver, i (driver.driver + driver.laps[0].race + ($State.intro.length > 1))}

				<!-- <path class="path-line" d="{chartLine(driver.laps)}" out:fade="{{duration: 300}}"></path> -->
				<path on:click={selectLine} 
					on:mousemove={throttle(mouseMove, 200)} 
					class="path-line" 
					data-value="{driver.driver}" 
					class:highlighted="{driver.driver === pickedDot.driver}" 
					class:selected="{driver.driver === $State.selDriver}" 
					d="{chartLine(driver.laps)}" 
					in:draw="{{duration: 3000, easing: linear}}" 
					on:introstart="{() => { playing=true; if (i===0) { !$State.intro && playSound();} }}"
					on:introend="{() => playing=false}"
					>
				</path>
			{/each}
			{/key}
		</g>


		<!-- Points region label -->
		<!-- <g class = "pointsRegion">
			<rect class="pointsLine" x="{$State.l_x(0)}" y="444" height="2" width="{($State.l_x(xExtent[1])+$State.l_x(0))/2-$State.l_x(0)-35}"/>
			<rect class="pointsLine" x="{($State.l_x(xExtent[1])+$State.l_x(0))/2+35}" y="444" height="2" width="{$State.l_x(xExtent[1])-(($State.l_x(xExtent[1])+$State.l_x(0))/2+35)}"/>
			<text class="pointsLabel" x="{($State.l_x(xExtent[1])+$State.l_x(0))/2}" y="450" >POINTS</text>
		</g> -->
		<!-- x axis -->
		<g class="axis x-axis">
				<g class="tick">
					<line y1="{height-20}" y2="{height-15}" x1="{$State.l_x(0)}" x2="{$State.l_x(0)}" style="stroke:#aaa;"></line>
					<text y="{height-2}" x="{$State.l_x(0)}">Median</text>
				</g>
				<text y="{height-2}" x="{$State.l_x(xExtent[0])}">Slower than average</text>
				<text y="{height-2}" x="{$State.l_x(xExtent[1])}" style="text-anchor:end">Faster than average</text>
		</g>



		<!-- Tooltip Leader line and dot -->
		{#if pickedDot.driver && !playing}
			<!-- <g transition:fade="{{duration: 200}}"> -->
			<g>
				<rect class="ttLine" 
					x="{$State.l_x(pickedDot.vsP105)}" 
					y="{$State.l_y(pickedDot.lap)-1}" 
					width="{!scaled ? 700 - $State.l_x(pickedDot.vsP105) : 2}" 
					height="{!scaled ? 2 : height - $State.l_y(pickedDot.lap)}"
				/>
				<circle class="chart-dot" cx="{$State.l_x(pickedDot.vsP105)}" cy="{$State.l_y(pickedDot.lap)}" r="4"/>
			</g>
		{/if}
	</svg>

	{/if}

	{#if pickedDot.driver && !playing}
		<div class="tooltip"  
			class:scaled={scaled} 
			style="
				left: {!scaled ? width : $State.l_x(pickedDot.vsP105) - (pickedDot.vsP105 > 0 ? 210 : 20)}px; 
				top:{!scaled ? Math.round($State.l_y(pickedDot.lap))-(pickedDot.lap < 40 ? 20 : 50) : height}px;
				{scaled && pickedDot.vsP105 > 0 ? 'text-align: right' : ''}
				" 
		>
			<div class="ttDriver" class:picked="{pickedDot.driver === $State.selDriver}">{pickedDot.driver + (scaled ? ' - P' + pickedDot.pos : '')}</div>
			{#if !scaled}<div class="ttLapPos">Lap {pickedDot.lap} - P{pickedDot.pos}</div>{/if}
			<div class="ttTime">{scaled ? 'Lap ' + pickedDot.lap + ' ' : ''}<strong>{pickedDot.pos === 1 ? "Race Lead" : Math.round(pickedDot.vsP1/100)/10}</strong>{pickedDot.pos === 1 ? "" :  " sec behind"}</div>
		</div>
	{/if}
</div>

</container>

		
	
<style>
	container {
		display: block;
		position: absolute;
		width: 100%;
	}

	.tick line{
		stroke: #333;
		stroke-dasharray: 5;
	}
	
	.y-axis {
		fill: #444;
		font-size: 12px;
	}
	
	.pointsLine {
		fill: #5C86B5;
	}

	.pointsLabel {
		text-anchor: middle;
		fill: #5C86B5;
		font-family: "Poppins", sans-serif;
		font-weight: 900;
		font-size: 14px;
	}

	.ttLine {
		fill:url(#grad-ttLine);
		pointer-events: none;
	}

	.ttDriver {
		color: #77A0CE;
		font-family: Poppins, sans-serif;
		font-style: italic;
		font-weight: 900;
		font-size: 14px;
		line-height: 16px;
		text-transform: uppercase;
	}

	.ttLapPos {
		font-family: Poppins, sans-serif;
		font-weight: 400;
		font-size: 12px;
		line-height: 16px;
		color: #999999;
	}


	.ttTime {
		font-family: Poppins, sans-serif;
		font-style: italic;
		font-size: 12px;
		line-height: 20px;
	}

	.ttTime strong{
		font-size: 14px;
		font-weight: 600;
	}

	.chart-dot {
		pointer-events: none;
		fill: #ECFAF9;
		filter:blur(1px);
		-webkit-filter:blur(1px);
		/* filter: url(#blur1); */
	}

	.tooltip {
		display: block;
		position: absolute;
		top: 0;

		width: 155px;
		height: 70px;
		padding: 10px 15px;

		/* background: linear-gradient(315deg, #1C1819 0%, #1E2023 100%);
		box-shadow: 5px 5px 10px #000000;
		border-radius: 8px;
		box-sizing: border-box; */

	}

	.scaled {
		width: 195px;
	}

	.picked {
		color: #FF3263;
	}


	.chart {
		width: 100%;
		max-width: 700px;
		max-height: 450px;
	}

	svg {
		position: relative;
		width: 100%;
		height: 450px; 
		overflow: hidden;
	}
	@media screen and (max-height: 770px) {
		svg {
			height: 400px; 
		}
		.chart {
			max-height: 400px;
		}
	}

	.path-line {
		fill: none;
		stroke: url(#grad-blue2whiteTween);
		stroke-linejoin: round;
		stroke-linecap: round;
		stroke-width: 4;
		filter: blur(0.6px);
		-webkit-filter: blur(0.6px);
		/* filter: url(#blur0-6); */
	}	
	.path-line.highlighted {
		stroke:  url(#grad-grey2white);
		filter: blur(0.3px);
		-webkit-filter: blur(0.3px);
		/* filter: url(#blur0-3); */
	}	
	
	
	.path-line.selected {
		stroke:  url(#grad-red2whiteTween);
		filter: blur(0.7px);
		-webkit-filter: blur(0.7px);
		/* filter: url(#blur0-6); */
		stroke-width: 6;
	}	


</style>